/* eslint-disable indent */
import {
  AddToCalendarModal,
  AssignPaymentModal,
  BookAVisitUpdatedModal,
  BookingConfirmationModal,
  CallHospitalModal,
  ClosePetModal,
  ConfirmClosureModal,
  ContactHospitalModal,
  ExpressBookingConfirmationModal,
  ExpressServiceUpsellModal,
  GenericPaymentIssueModal,
  ExpressVisitInfoModal,
  ExpressVisitModal,
  LogoutModal,
  OverdueContactModal,
  PendingInvoiceAlertModal,
  PendingInvoicePausedAlertModal,
  PendingInvoiceCancelledAlertModal,
  PostToGoogleModal,
  RatingReviewModal,
  RescheduleAVisitModal,
  RescheduleDropOffModal,
  RescheduleUrgentVisitModal,
  RescheduleExpressVisitModal,
  RescheduleVisitConfirmationModal,
  SelectedTimeUnavailableModal,
  UpdateHospitalModal,
  UpdatePaymentErrorModal,
  UpdatePaymentMethodModal,
  UrgentCareTransitionModal,
  UrgentVisitModal,
  UserDeleteModalRedirect,
  ViewPastAppointmentReview,
  WellnessPlanUpdateModal,
  WellnessPlanUpdatePopUpModal,
  WellnessUpdateConfirmationModal,
  QuickShareUpsellModal,
  InviteUpsellModal,
  WellnessPlanEndedAlert,
  WellnessPlanRenewUnsuccessfulAlert,
  WellnessPlanRenewalSuccessfulAlert,
  WellnessPlanReminders,
  WellnessPlanPaymentErrorModal,
  PetBirthdayFormModal,
  WellnessRenewalUpsellModal,
  WellnessPlanTransitionSuccessModal,
  CancelUpcomingPlanRenewalModal,
  CancelUpcomingPlanRenewalSuccessModal,
  PaymentInformationModal,
  ScratchPaySuccessModal,
  ScratchPayRenewalPendingModal,
  VetCoveRedirectModal,
  CustomerSupportModal,
  ScratchPayInfoModal,
  PrequalInterceptorModal,
} from "../../shared/modals";
import {
  AppointmentReviewContainer,
  CancelAppointmentConfirmation,
  MsaChangeContainer,
  NewPetContainer,
  NotificationContainer,
  PrequalSelectPetContainer,
  WellnessPlanSelectPetContainer,
  WellnessPlanSuccessContainer,
} from "../../shared/containers";
// eslint-disable-next-line max-len
import PrescriptionDetailsContainer from "../../shared/containers/StoreContainer/PrescriptionsContent/components/PrescriptionDetailsContainer/PrescriptionDetailsContainer";
import { DRAWERS, MODALS } from "../../config/params";
import { DrawerCustom, ModalCustom } from "..";
import React, { FC, useEffect } from "react";

import AddPaymentMethodModal from "../../shared/modals/AddPaymentMethodModal/AddPaymentMethodModal";
import ManageHospitalChangeModal from "../../shared/modals/ManageHospitalChangeModal/ManageHospitalChangeModal";
import NewCancelContainer from "../../shared/containers/VisitCancelContainer/NewCancelContainer";
import SelectPetModal from "../../shared/modals/SelectPetModal/SelectPetModal";
import UpdateHospitalErrorModal from "../../shared/modals/UpdateHospitalErrorModal/UpdateHospitalErrorModal";
import UpdateHospitalPreviewModal from "../../shared/modals/UpdateHospitalPreviewModal/UpdateHospitalPreviewModal";
import UserDeleteModal from "../../shared/modals/UserDeleteModal/UserDeleteModal";
import { useDrawer } from "../../context/DrawerContext";
import { useModal } from "../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import DuplicateAccountAlertModal from "../../shared/modals/DuplicateAccountAlertModal/DuplicateAccountAlertModal";
import GroupedAppointmentActionModal
  from "../../shared/modals/GroupedAppointmentActionModal/GroupedAppointmentActionModal";
const Wrapper: FC = ({ children }) => {
  const navigate = useNavigate();

  const { displayModal, closeModal, modalView } = useModal();
  const { displayDrawer, closeDrawer, drawerView } = useDrawer();

  useEffect(() => {
    closeModal();
    closeDrawer();
  }, [navigate]);

  const getDrawerVariant = (drawerView?: string): "medium" | "large" => {
    switch (drawerView) {
      case DRAWERS.PRESCRIPTION_DETAILS:
        return "large";
      default:
        return "medium";
    }
  };

  return (
    <>
      {children}

      <ModalCustom open={displayModal} onClose={closeModal}>
        <>
          {modalView === MODALS.ADD_TO_CALENDAR && <AddToCalendarModal />}
          {modalView === "LOGOUT" && <LogoutModal />}
          {modalView === MODALS.SELECT_PET_MODAL && <SelectPetModal />}
          {modalView === MODALS.RESCHEDULE_A_VISIT && <RescheduleAVisitModal />}
          {modalView === MODALS.VISIT_CANCEL && <NewCancelContainer />}
          {modalView === MODALS.CLOSE_PET_MODAL && <ClosePetModal />}
          {modalView === MODALS.CALL_HOSPITAL_MODAL && <CallHospitalModal />}
          {modalView === MODALS.CLOSE_PET_CONFIRMATION && <ConfirmClosureModal />}
          {modalView === MODALS.OVERDUE_CONTACT_MODAL && <OverdueContactModal />}
          {modalView === MODALS.PENDING_INVOICE_ALERT_MODAL && <PendingInvoiceAlertModal />}
          {modalView === MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL && <PendingInvoicePausedAlertModal />}
          {modalView === MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL && <PendingInvoiceCancelledAlertModal />}
          {modalView === MODALS.GENERIC_PAYMENT_ISSUE_MODAL && <GenericPaymentIssueModal />}
          {modalView === MODALS.USER_DELETE && <UserDeleteModal />}
          {modalView === MODALS.RESCHEDULE_DROP_OFF_MODAL && <RescheduleDropOffModal />}
          {modalView === MODALS.RESCHEDULE_URGENT_VISIT_MODAL && <RescheduleUrgentVisitModal />}
          {modalView === MODALS.EXPRESS_SERVICE_UPSELL_MODAL && <ExpressServiceUpsellModal />}
          {modalView === MODALS.ASSIGN_PAYMENT_MODAL && <AssignPaymentModal />}
          {modalView === MODALS.UPDATE_PAYMENT_ERROR_MODAL && <UpdatePaymentErrorModal />}
          {modalView === MODALS.EXPRESS_VISIT_MODAL && <ExpressVisitModal />}
          {modalView === MODALS.EXPRESS_BOOKING_CONFIRMATION_MODAL && <ExpressBookingConfirmationModal />}
          {modalView === MODALS.EXPRESS_VISIT_INFO_MODAL && <ExpressVisitInfoModal />}
          {modalView === MODALS.RESCHEDULE_EXPRESS_VISIT_MODAL && <RescheduleExpressVisitModal />}
          {modalView === MODALS.UPDATED_BOOK_A_VISIT_MODAL && <BookAVisitUpdatedModal />}
          {modalView === MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL && <BookingConfirmationModal />}
          {modalView === MODALS.URGENT_CARE_TRANSITION_MODAL && <UrgentCareTransitionModal />}
          {modalView === MODALS.URGENT_VISIT_MODAL && <UrgentVisitModal />}
          {modalView === MODALS.PET_BIRTHDAY_FORM_MODAL && <PetBirthdayFormModal />}
          {modalView === MODALS.USER_DELETE_REDIRECT && <UserDeleteModalRedirect />}
          {modalView === MODALS.RESCHEDULE_CONFIRMATION && <RescheduleVisitConfirmationModal />}
          {modalView === MODALS.ADD_A_PET && <NewPetContainer />}
          {modalView === MODALS.UPDATE_HOSPITAL && <UpdateHospitalModal />}
          {modalView === MODALS.ADD_PAYMENT_METHOD && <AddPaymentMethodModal />}
          {modalView === MODALS.APPOINTMENT_REVIEW && <AppointmentReviewContainer />}
          {modalView === MODALS.MANAGE_HOSPITAL_CHANGE && <ManageHospitalChangeModal />}
          {modalView === MODALS.UPDATE_HOSPITAL_PREVIEW && <UpdateHospitalPreviewModal />}
          {modalView === MODALS.UPDATE_HOSPITAL_ERROR && <UpdateHospitalErrorModal />}
          {modalView === MODALS.CANCEL_BOOK_A_VISIT && <CancelAppointmentConfirmation />}{" "}
          {modalView === MODALS.WELLNESS_PLAN_SELECT_PET && <WellnessPlanSelectPetContainer />}
          {modalView === MODALS.PREQUAL_SELECT_PET && <PrequalSelectPetContainer />}
          {modalView === MODALS.PREQUAL_INTERCEPTOR_MODAL && <PrequalInterceptorModal />}
          {modalView === MODALS.MSA_CHANGE_MODAL && <MsaChangeContainer />}
          {modalView === MODALS.CANCEL_PLAN_RENEWAL && <WellnessPlanUpdateModal />}
          {modalView === MODALS.CANCEL_PLAN_RENEWAL_SUCCESS && <WellnessUpdateConfirmationModal />}
          {modalView === MODALS.CONTACT_HOSPITAL && <ContactHospitalModal />}
          {modalView === MODALS.WELLNESS_PLAN_PAYMENT_SUCCESS && <WellnessPlanSuccessContainer />}
          {modalView === MODALS.UPDATE_PAYMENT_METHOD_MODAL && <UpdatePaymentMethodModal />}
          {modalView === MODALS.RATING_REVIEW_MODAL && <RatingReviewModal />}
          {modalView === MODALS.VIEW_RATING_REVIEW_MODAL && <ViewPastAppointmentReview />}
          {modalView === MODALS.POST_TO_GOOGLE_MODAL && <PostToGoogleModal />}
          {modalView === MODALS.DUPLICATE_ACCOUNT_ALERT_MODAL && <DuplicateAccountAlertModal />}
          {modalView === MODALS.EXPIRED_PAYMENT_UPDATE_MODAL && <WellnessPlanUpdatePopUpModal />}
          {modalView === MODALS.SELECTED_TIME_UNAVAILABLE && <SelectedTimeUnavailableModal />}
          {modalView === MODALS.QUICK_SHARE_UPSELL_MODAL && <QuickShareUpsellModal />}
          {modalView === MODALS.INVITE_UPSELL_MODAL && <InviteUpsellModal />}
          {modalView === MODALS.WELLNESS_PLAN_ENDED_ALERT && <WellnessPlanEndedAlert />}
          {modalView === MODALS.WELLNESS_PLAN_RENEW_UNSUCCESSFUL_ALERT && <WellnessPlanRenewUnsuccessfulAlert />}
          {modalView === MODALS.WELLNESS_PLAN_RENEWAL_SUCCESSFUL_ALERT && <WellnessPlanRenewalSuccessfulAlert />}
          {modalView === MODALS.WELLNESS_PLAN_RENEWAL_REMINDERS && <WellnessPlanReminders />}
          {modalView === MODALS.WELLNESS_PLAN_PAYMENT_ERROR_MODAL && <WellnessPlanPaymentErrorModal />}
          {modalView === MODALS.WELLNESS_RENEWAL_UPSELL && <WellnessRenewalUpsellModal />}
          {modalView === MODALS.WELLNESS_PLAN_TRANSITION_SUCCESS && <WellnessPlanTransitionSuccessModal />}
          {modalView === MODALS.CANCEL_UPCOMING_PLAN_RENEWAL && <CancelUpcomingPlanRenewalModal />}
          {modalView === MODALS.CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS && <CancelUpcomingPlanRenewalSuccessModal />}
          {modalView === MODALS.PAYMENT_INFORMATION_MODAL && <PaymentInformationModal />}
          {modalView === MODALS.SCRATCHPAY_SUCCESS_MODAL && <ScratchPaySuccessModal />}
          {modalView === MODALS.SCRATCHPAY_RENEWAL_PENDING_MODAL && <ScratchPayRenewalPendingModal />}
          {modalView === MODALS.VETCOVE_REDIRECT_MODAL && <VetCoveRedirectModal />}
          {modalView === MODALS.GROUPED_APPOINTMENT_ACTION && <GroupedAppointmentActionModal />}
          {modalView === MODALS.CUSTOMER_SUPPORT_MODAL && <CustomerSupportModal />}
          {modalView === MODALS.SCRATCHPAY_INFO_MODAL && <ScratchPayInfoModal />}
        </>
      </ModalCustom>

      <DrawerCustom open={displayDrawer} onClose={closeDrawer} variant={getDrawerVariant(drawerView)}>
        <>
          {drawerView === DRAWERS.NOTIFICATIONS && <NotificationContainer />}
          {drawerView === DRAWERS.PRESCRIPTION_DETAILS && <PrescriptionDetailsContainer />}
        </>
      </DrawerCustom>
    </>
  );
};

export default Wrapper;
